var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import DataTable from '@/components/data-table/DataTable';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { RolesEnum } from '@/items/Roles';
import { Event as EventModel } from '@/models/Event';
import { Student } from '@/models/Student';
import { UserSubject } from '@/models/UserSubject';
import ErrorHandler from '@/support/ErrorHandler';
import { lessonTypeIcons, whiteAreaIcons, whiteKidIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import { formatDate as format, replaceUrlsWithAnchorTags } from '@/support/String';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let ChooseEventDialog = class ChooseEventDialog extends Vue {
    constructor() {
        super(...arguments);
        this.godMode = false;
        this.hasChosenForStudentDialog = false;
        this.parsedEvents = [];
        this.newEvent = null;
        this.userSubjects = [];
        this.selectedEventId = null;
        this.lessonTypeIcons = null;
        this.subjects = [];
        this.choosingEventMap = {};
        this.gridSizeMap = {
            1: 'sm10 md6 lg4 xl3',
            2: 'sm10 md6 lg4 xl3',
            3: 'sm10 md6 lg4 xl3',
            4: 'sm10 md6 lg4 xl3',
            5: 'sm10 md6 lg4 xl3',
            6: 'sm10 md6 lg4 xl3',
            7: 'sm10 md6 lg4 xl3',
            8: 'sm10 md6 lg4 xl3',
            9: 'sm10 md6 lg4 xl3',
            10: 'sm10 md6 lg4 xl3',
            11: 'sm10 md6 lg4 xl3',
            12: 'sm10 md6 lg4 xl3',
        };
        this.visibility = {
            checkboxes: false,
            search: false,
        };
    }
    get gridSize() {
        if (!this.parsedEvents) {
            return 'sm12';
        }
        return this.gridSizeMap[this.parsedEvents.length] || 'sm12';
    }
    get tableOptionsEvents() {
        return {
            name: {
                singular: this.$tc('rosterTemplate.dialog.header.activities', 1),
                plural: this.$tc('rosterTemplate.dialog.header.activities', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'datetimeslots',
                    width: '3px',
                    style: { position: 'relative' },
                    transform: (value, event) => {
                        return event.meta && event.meta.totals && event.meta.totals.datetimeslots > 1 ? `<div class="doublePeriodLine"></div>` : '';
                    },
                },
                {
                    text: '',
                    value: 'avatar',
                    transform: (value, event) => {
                        if (!event.teacher) {
                            return '';
                        }
                        return `<img class="avatar avatar-small" src="${event.teacher.avatar}">`;
                    },
                },
                {
                    text: this.$tc('roles.teacher', 1),
                    value: 'teacher',
                    transform: (value, event) => {
                        if (!event.teacher) {
                            return '';
                        }
                        return `${event.teacher.name}`;
                    },
                },
                {
                    text: this.$tc('subject.area.title', 1),
                    value: 'areas',
                    transform: (subjects, event) => {
                        if (event.type === 'recess') {
                            return 'RECESS';
                        }
                        let str = '';
                        subjects.forEach((subject) => { str += `${subject.name}, `; });
                        return str.substring(0, str.length - 2);
                    },
                },
                {
                    text: this.$tc('room.title', 1),
                    value: 'room',
                    transform: (room) => {
                        return room ? room.name : '';
                    },
                },
                {
                    text: this.$tc('level.title', 2),
                    value: 'levels',
                    transform: (levels) => {
                        let str = '';
                        levels.forEach((level) => { str += `${level.name}, `; });
                        return `<span class="${levels[0] && levels[0].is_mandatory ? 'is_mandatory' : ''}">${str.substring(0, str.length - 2)}</span>`;
                    },
                },
                {
                    text: this.$tc('group.title', 2),
                    value: 'groups',
                    transform: (groups) => {
                        let str = '';
                        groups.forEach((group) => { str += `${group.name}, `; });
                        return `<span class="${groups[0] && groups[0].is_mandatory ? 'is_mandatory' : ''}">${str.substring(0, str.length - 2)}</span>`;
                    },
                },
                {
                    text: this.$tc('roles.student', 2),
                    value: 'meta',
                    transform: (meta) => {
                        if (meta.totals && meta.totals.chosen) {
                            return `${meta.totals.chosen} ${this.$tc('roles.student', meta.totals.chosen)}`;
                        }
                        return 'n/a';
                    },
                },
            ],
            actions: [
                {
                    type: 'add',
                    label: 'add',
                    icon: (vm, event) => {
                        if (!event || !event.room) {
                            return;
                        }
                        const roomCapacity = parseInt(event.room.capacity);
                        return roomCapacity > event.meta.totals.chosen ? 'person_add' : 'person_add_disabled';
                    },
                    action: (vm, event) => {
                        if (!event || !event.room || !event.id) {
                            return;
                        }
                        const roomCapacity = parseInt(event.room.capacity);
                        if (roomCapacity <= event.meta.totals.chosen) {
                            return;
                        }
                        this.chooseEventGodMode(event);
                        // this.selectedEvent = event;
                        // this.isCreatingEventDialog = true;
                    },
                },
            ],
            filters: [],
            model: new EventModel().limit(100).include(['teacher', 'subjects', 'areas', 'levels', 'groups', 'room', 'meta']).filter({ datetimeslots: [this.datetimeslot] || [], god: true }),
        };
    }
    get icons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    get dialogOptionsHasChosen() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('event.godmodeChosen').toString(),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.hasChosenForStudentDialog = false;
                    },
                },
            },
        };
    }
    mounted() {
        this.lessonTypeIcons = lessonTypeIcons;
        this.fetchEvents();
    }
    close() {
        this.$emit('input', false);
        this.$emit('dialogClosed', true);
        this.clear();
    }
    clear() {
        this.newEvent = new EventModel();
    }
    fetchEvents() {
        new EventModel()
            .include(['users', 'user', 'room', 'levels', 'groups', 'subjects', 'areas', 'events', 'teacher', 'lesson_type', 'datetimeslots', 'meta'])
            .filter({
            datetimeslots: [this.datetimeslot],
            users: this.student ? [this.student.id] : [this.$store.state.Auth.id],
        })
            .all()
            .then((events) => {
            this.$set(this, 'parsedEvents', events);
            this.getUserSubjects();
            const map = {};
            events.forEach((event) => {
                if (event.id) {
                    map[event.id] = false;
                }
            });
            this.$set(this, 'choosingEventMap', map);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    isEventChosen(event) {
        if (!event.users) {
            return false;
        }
        let chosen = false;
        const user = event.users.find((user) => {
            if (this.student) {
                return user.id === this.student.id;
            }
            return user.id === this.$store.state.Auth.id;
        });
        if (user && user.is_chosen) {
            chosen = true;
        }
        return chosen;
    }
    isEventFull(event) {
        const maxCapacity = event.room && event.room.capacity ? parseInt(event.room.capacity) : 0;
        const currentCapacity = event.meta && event.meta.totals && event.meta.totals.chosen ? parseInt(event.meta.totals.chosen) : 0;
        return currentCapacity >= maxCapacity;
    }
    getUserSubjects() {
        let subjects = [];
        this.parsedEvents.forEach((event) => {
            if (event.subjects) {
                const eventSubjects = event.subjects.map((subject) => {
                    return subject.id;
                });
                subjects = [...subjects, ...eventSubjects];
            }
        });
        this.$set(this, 'subjects', subjects);
        new UserSubject()
            .include('status')
            .user(this.student ? this.student.id : this.$store.state.Auth.id)
            .filter('subjects', subjects)
            .all()
            .then((userSubjects) => {
            this.userSubjects = userSubjects;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    getSubjectStatus(subject) {
        if (!this.userSubjects) {
            return '';
        }
        let status = 'inactive';
        const userSubject = this.userSubjects.find((userSubject) => {
            return userSubject.subject === subject.id;
        });
        if (userSubject && userSubject.status) {
            status = userSubject.status;
        }
        return status;
    }
    subjectStatusLabel(subject) {
        if (!this.userSubjects) {
            return '';
        }
        let status = 'inactive';
        const userSubject = this.userSubjects.find((userSubject) => {
            return userSubject.subject === subject.id;
        });
        if (userSubject && userSubject.status) {
            status = userSubject.status;
        }
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    lessonTypeIcon(iconName) {
        return this.lessonTypeIcons[iconName];
    }
    chooseEventGodMode(selectedEvent) {
        selectedEvent.choose(this.student ? this.student : this.$store.state.Auth).then(() => {
            this.$emit('eventChosen');
            this.hasChosenForStudentDialog = true;
            this.fetchEvents();
        })
            .catch((error) => {
            this.selectedEventId = null;
            let mandatoryError = false;
            if (error.response && error.response.data.errors) {
                Object.keys(error.response.data.errors).forEach((key) => {
                    if (key === 'event_user.is_mandatory') {
                        mandatoryError = true;
                    }
                });
            }
            if (mandatoryError) {
                ErrorHandler.alert(this.$t('roster.dialog.mandatoryErrorMessage').toString(), this.$t('roster.dialog.mandatoryErrorTitle').toString());
            }
            else {
                ErrorHandler.network(error);
            }
        });
    }
    chooseEvent(eventId) {
        this.$set(this.choosingEventMap, eventId, true);
        this.selectedEventId = eventId;
        const eventIndex = this.parsedEvents.findIndex((event) => {
            return event.id == this.selectedEventId;
        });
        let event = this.parsedEvents[eventIndex];
        if (event) {
            event = new EventModel(event);
            event.choose(this.student ? this.student : this.$store.state.Auth).then(() => {
                this.$emit('eventChosen');
                this.$set(this.choosingEventMap, eventId, false);
                this.fetchEvents();
                // this.parsedEvents[eventIndex].is_chosen = true;
                // this.selectedEventId = null;
            })
                .catch((error) => {
                this.selectedEventId = null;
                this.$set(this.choosingEventMap, eventId, false);
                let mandatoryError = false;
                if (error.response && error.response.data.errors) {
                    Object.keys(error.response.data.errors).forEach((key) => {
                        if (key === 'event_user.is_mandatory') {
                            mandatoryError = true;
                        }
                    });
                }
                if (mandatoryError) {
                    ErrorHandler.alert(this.$t('roster.dialog.mandatoryErrorMessage').toString(), this.$t('roster.dialog.mandatoryErrorTitle').toString());
                }
                else {
                    ErrorHandler.network(error);
                }
            });
        }
    }
    getEventStart(event) {
        if (!event.datetimeslots) {
            return null;
        }
        return event.datetimeslots[0].starts_at;
    }
    getEventEnd(event) {
        if (!event.datetimeslots) {
            return null;
        }
        if (event.datetimeslots.length > 1) {
            return event.datetimeslots[event.datetimeslots.length - 1].ends_at;
        }
        return event.datetimeslots[0].ends_at;
    }
    parseEventDescription(description) {
        return replaceUrlsWithAnchorTags(description);
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER, RolesEnum.BOARD]);
    }
    slotChanged(datetimeslot) {
        this.parsedEvents = [];
        if (datetimeslot.length) {
            this.fetchEvents();
        }
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], ChooseEventDialog.prototype, "datetimeslot", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], ChooseEventDialog.prototype, "hardlock", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], ChooseEventDialog.prototype, "start", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], ChooseEventDialog.prototype, "end", void 0);
__decorate([
    Prop({ default: new Student }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], ChooseEventDialog.prototype, "student", void 0);
__decorate([
    Watch('datetimeslot'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ChooseEventDialog.prototype, "slotChanged", null);
ChooseEventDialog = __decorate([
    Component({
        components: {
            SelectFilter,
            DataTable,
        },
        filters: {
            formatDate(date) {
                return !date ? '' : format(date, 'dd-LL-yyyy');
            },
            formatTime(time) {
                return !time ? '' : format(time, 'HH:mm');
            },
            formatDay(date) {
                return !date ? '' : format(date, 'cccc');
            },
        },
    })
], ChooseEventDialog);
export default ChooseEventDialog;
